import React from 'react';
import PropTypes from 'prop-types';

const FullPageLayout = ({ className, style, children }) => {
  return (
    <div className={`FullPageLayout ${className}`} style={style}>
      {children}
    </div>
  );
}

FullPageLayout.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
}

FullPageLayout.defaultProps = {
  className: '',
  style: {},
}

export default FullPageLayout;



// WEBPACK FOOTER //
// ./src/components/FullPageLayout/FullPageLayout.js